var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("stats-infos", {
            attrs: { user: _vm.selectedUser, dates: _vm.datesForStatsInfos }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("stats-calendar", {
            attrs: { user: _vm.selectedUser },
            on: { "date-change": _vm.calendarDateChanged }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }